import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../lib/supabase';

// Navigacione komponente
import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';

// Statusne komponente
import StatCard from './components/StatCard';
import UpgradeModal from './components/UpgradeModal';

const StatsDashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const [adminData, setAdminData] = useState({
    nome: '',
    ruolo: ''
  });

  useEffect(() => {
    fetchAdminData();
  }, [t]);

  const fetchAdminData = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (user) {
        const { data: profilo, error: profError } = await supabase
          .from('profili')
          .select('nome, cognome, ruolo')
          .eq('id', user.id)
          .single();

        if (profilo && !profError) {
          setAdminData({
            nome: `${profilo.nome} ${profilo.cognome}`,
            ruolo: profilo.ruolo
          });
        }
      }
    } catch (err) {
      console.error("Greška pri učitavanju podataka:", err.message);
    }
  };

  const handleLogout = () => navigate('/landing-authentication');
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <MobileMenuButton isOpen={isSidebarOpen} onClick={toggleSidebar} />
      <DashboardSidebar isCollapsed={!isSidebarOpen} onToggle={toggleSidebar} />
      <DashboardHeader onLogout={handleLogout} userName={adminData.nome || 'Admin'} />

      <main className="main-content with-sidebar">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
          
          {/* Ovdje se prosljeđuje funkcija koja otvara modal */}
          <StatCard 
            userName={adminData.nome} 
            onUpgradeClick={() => setIsUpgradeModalOpen(true)} 
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
            <div className="lg:col-span-2">
              {/* Ovdje možeš ubaciti neku listu ili grafikon u budućnosti */}
            </div>
          </div>
        </div>
      </main>

      <DashboardFooter />

      {/* KLJUČNI DIO: Modal mora biti ovdje da bi se mogao prikazati */}
      <UpgradeModal 
        isOpen={isUpgradeModalOpen} 
        onClose={() => setIsUpgradeModalOpen(false)} 
        currentPlan={adminData.ruolo || 'Standard'} 
      />
    </div>
  );
};

export default StatsDashboard;